module.exports = __webpack_public_path__ + "img/vip-coupon-btn-bg.6f1613ab.png";